<template>
  <div class="mt-1">
    <ValidationProvider
      v-if="condition"
      :vid="validation_label"
      :name="validation_label"
      rules=""
      v-slot="{ errors }"
    >
      <div class="upload-btn-wrapper">
        <button
          :class="{
            btn_success: file || (!errors[0] && !fileError),
            btn_danger: (!file && !!errors[0]) || fileError
          }"
        >
          Upload a file
        </button>
        <input
          accept=".doc, .jpg, .pdf, .jpeg, .png, .docx, .txt, .mp4"
          @change="fileUploader($event)"
          type="file"
          name="myfile"
        />
      </div>

      <!-- Display size warning -->
      <small v-if="fileError" class="text-danger">
        ⚠️ {{ fileError }}
      </small>
      <br>
      <!-- Optional helpful guide -->
      <small class="text-muted d-block mt-1">
        Supported formats: .doc, .jpg, .pdf, .jpeg, .png, .docx, .txt, .mp4  
        Max file size: {{ (maxFileSize / 1024 / 1024).toFixed(1) }} MB
      </small>
    </ValidationProvider>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const FileRepository = RepositoryFactory.get('file')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'multi-file-uploader',
  props: {
    file: String,
    condition: {
      type: Boolean,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    },
    file_path: {
      type: String,
      default: 'general'
    },
    maxFileSize: {
      type: Number,
      default: 25 * 1024 * 1024 // 25MB in bytes
    }
  },
  data() {
    return {
      validation_label: (Math.floor(Math.random() * 999999) + 1) + ' ',
      fileError: null
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async fileUploader(event) {
      const file = event.target.files[0]
      this.fileError = null

      // ✅ Validate file size before uploading
      if (file && file.size > this.maxFileSize) {
        this.fileError = `File size exceeds the limit of ${(this.maxFileSize / 1024 / 1024).toFixed(1)} MB. Please upload a smaller file.`
        event.target.value = '' // clear input
        return
      }

      this.$vs.loading()
      try {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('path', this.file_path)

        const response = await FileRepository.uploadFileWithPath(formData)
        const file_name = response.data.data.file

        this.file = file_name
        this.$emit('onSetFileName', file_name)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style scoped>
.text-danger {
  color: #dc3545;
}
.text-muted {
  color: #6c757d;
}
.upload-btn-wrapper input[type="file"] {
  cursor: pointer;
}
</style>
